// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"69a5e8d8","239":"ad40150f","455":"b91e6987","879":"b17dfaf8"}[chunkId] + ".chunk.js";
};